import React, { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  ACQUIRED_ASSETS_AUTO_LOANS_LIST,
  ACQUIRED_ASSETS_PROPERTY_LIST,
} from "./paths";
const AutoLoansSecondHand = lazy(() =>
  import("Components/AcquiredAssets/AutoLoansSecondHand")
);
const PropertiesForSale = lazy(() =>
  import("Components/AcquiredAssets/PropertiesForSale")
);
const AcquiredVehiclesList = lazy(() => import("pages/AcquiredVehiclesList"));
const AcquiredPropertyList = lazy(() => import("pages/AcquiredPropertiesList"));

const AcquiredAssetsRoutes = () => {
  return (
    <Switch>
      <Route
        path="/acquired-assets/properties-for-sale"
        component={PropertiesForSale}
      />
      <Route
        path="/acquired-assets/auto-loans-second-hand"
        component={AutoLoansSecondHand}
      />
      <Route
        path={ACQUIRED_ASSETS_AUTO_LOANS_LIST}
        component={AcquiredVehiclesList}
      />
      <Route
        path={ACQUIRED_ASSETS_PROPERTY_LIST}
        component={AcquiredPropertyList}
      />
      <Route path="*" component={() => <Redirect to="/" />} />
    </Switch>
  );
};
export default AcquiredAssetsRoutes;
